import { startLoading, finishLoading } from "../modules/loading";

export default function createRequestThunk(type, request, afterTypeArr) {
    // 성공 및 실패 액션 타입을 정의합니다.
    const SUCCESS = `${type}_SUCCESS`;
    const FAILURE = `${type}_FAILURE`;

    return parms => async dispatch => {
        dispatch({ type });   // 시작됨
        dispatch(startLoading(type));

        // console.log("createRequestThunk called - ", parms);

        try {
            const reponse = await request(parms);

            if (reponse.data.isSuccessed === true) {
                dispatch({
                    type: SUCCESS,
                    parms: parms,
                    payload: reponse.data
                }); // 성공

                if (afterTypeArr !== undefined && afterTypeArr !== null) {
                    afterTypeArr.forEach(typeName => {
                        dispatch({
                            type: typeName,
                            parms: parms,
                            payload: reponse.data
                        });
                    });
                }
            } else {
                dispatch({
                    type: SUCCESS,
                    parms: parms,
                    payload: reponse.data
                }); // 성공
            }
            dispatch(finishLoading(type))
        } catch (e) {
            dispatch({
                type: FAILURE,
                payload: e,
                error: true
            }); // 에러 발생
            dispatch(startLoading(type))
            throw e;
        }
    }
}